import logreg from './js/logreg';
export default {
  name: 'thirdwrap',
  props: {
    thirdHost: {
      type: String,
      default: ''
    },
    oldThirdHost: {
      type: String,
      default: ''
    },
    clientId: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginWays: [{
        name: 'tw',
        url: "//".concat(this.thirdHost, "/third/authorize?plat=13&display=iframe&redirect=http%3A%2F%2F").concat(this.oldThirdHost, "%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D").concat(this.clientId, "%26display%3Diframe%26geo%3Den%26redirect_uri%3D").concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.host, "/")))
      }, {
        name: 'google',
        url: "//".concat(this.thirdHost, "/third/authorize?plat=4&display=iframe&redirect=http%3A%2F%2F").concat(this.oldThirdHost, "%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D").concat(this.clientId, "%26display%3Diframe%26geo%3Den%26redirect_uri%3D").concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.host, "/")))
      }, {
        name: 'ins',
        url: "//".concat(this.thirdHost, "/third/authorize?plat=9&display=iframe&redirect=http%3A%2F%2F").concat(this.oldThirdHost, "%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D").concat(this.clientId, "%26display%3Diframe%26geo%3Den%26redirect_uri%3D").concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.host, "/")))
      }, {
        name: 'line',
        url: "//".concat(this.thirdHost, "/third/authorize?plat=17&display=iframe&redirect=http%3A%2F%2F").concat(this.oldThirdHost, "%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D").concat(this.clientId, "%26display%3Diframe%26geo%3Den%26redirect_uri%3D").concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.host, "/")))
      }]
    };
  },
  methods: {
    thirdLogin: function thirdLogin(name) {
      logreg.thirdLogin(name);
    },
    play: function play() {}
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};